import { createContext, useContext } from 'react';

import noop from 'utils/noop';

export interface FilterState {
  searchQuery: string;
  setSearchQuery: (value: string) => void;
}

export const FilterContext = createContext<FilterState>({
  searchQuery: '',
  setSearchQuery: noop,
});

export const useFilterContext = () => useContext(FilterContext);
